var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("specialist-certification-finding", {
    attrs: { "full-profile": _vm.fullProfile }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }